export default {
  admindigital: 'AdminDigital',
  artiflow: 'Artiflow',
  dashconnect: 'DashConnect',
  platform: 'Platform',

  title: 'Aplicações',
  description: 'Cadastre as aplicações do ecossistema e organize quais funcionalidades fazem parte de cada uma.',
  form:{
    title: 'Cadastro de Aplicação'
  },
  labels: {
    new: 'Nova Aplicação',
  },
  fields: {
    name: 'Nome da Aplicação',
    is_active: 'Ativo',
  },
  groups: {
    data: 'Dados cadastrais',
    modules: 'Módulos vinculados',
  },
};
